module.exports = {
  headers: {
    "Accept": "application/json",
    "Content-kind": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Origin": "*"
  },
  style: {
    base: {
      color: "#444",
      lineHeight: "1.3em",
      fontWeight: 400,
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "15px",
      '::placeholder': {
        color: "#bbb",
        fontWeight: 200
      }
    }
  }
}



// WEBPACK FOOTER //
// ./lib/config/stripe.js